<div class="form-group">
	<agence-selector
		[id]="'choixAgence'"
		[labelClass]="labelClass"
		[fieldClass]="shortFieldClass"
		[wildcardOptionLabel]="'Toutes'"
		[resetCommands]="_resetCommands"
		(selectedAgenceIdChange)="onSelectedAgenceIdChange($event)"
		>
	</agence-selector>
</div>

<ng-container *ngIf="showAntennes">
	<div class="form-group">
		<antenne-checkbox-list
			[id]="'choixAntennes'"
			[labelClass]="labelClass"
			[fieldClass]="longFieldClass"
			[agenceId]="agenceId"
			[resetCommands]="_resetCommands"
			(selectionIdsChange)="onSelectedAntenneIdsChange($event)"
			>
		</antenne-checkbox-list>
	</div>

	<ng-container *ngIf="showParcs">
		<div class="form-group">
			<parc-checkbox-list
				[id]="'choixParcs'"
				[labelClass]="labelClass"
				[fieldClass]="longFieldClass"
				[antenneIds]="antenneIds"
				[resetCommands]="_resetCommands"
				(selectionIdsChange)="onSelectedParcIdsChange($event)"
				>
			</parc-checkbox-list>
		</div>

		<ng-container *ngIf="showOuvrages">
			<div class="form-group">
				<sous-parc-checkbox-list
					[id]="'choixSousParcs'"
					[labelClass]="labelClass"
					[fieldClass]="longFieldClass"
					[parcIds]="parcIds"
					[resetCommands]="_resetCommands"
					[sousParcSelectionRequests]="sousParcSelectionSubject"
					(itemDeselected)="onSousParcDeselected($event)"
					(selectionIdsChange)="onSelectedSousParcIdsChange($event)"
					>
				</sous-parc-checkbox-list>
			</div>

			<div class="form-group">
				<ouvrage-checkbox-list
					[id]="'choixSousParcs'"
					[labelClass]="labelClass"
					[fieldClass]="longFieldClass"
					[parcIds]="parcIds"
					[resetCommands]="_resetCommands"
					[sousParcDeselectionRequests]="ouvragesDeselectionBySousParcSubject"
					(itemSelected)="onOuvrageSelected($event)"
					(selectionIdsChange)="onSelectedOuvrageIdsChange($event)"
					>
				</ouvrage-checkbox-list>
			</div>
		</ng-container>
	</ng-container>
</ng-container>	